export default "__VITE_ASSET__BbPFVyyj__"